import React from "react";
import {
  Row,
  Col,
  Card,Container
} from "react-bootstrap";
import './RatesAndFees.scss';

import { ReactComponent as First } from "../../assets/images/Icons_descargar.svg";
import  Pasos from "./../../assets/images/como-financiar.png";

function RatesAndSafes( ) {
  return (
    <div>


       
      
      <div className="fq-header wrapper">
        <span className="fq-title" style={{ marginTop: 60 }}>
        ¿Cómo funciona Fondos Colectivos?
        </span>
      </div>
<Container>
      <Row style={{ paddingLeft: "12%", paddingRight: "12%",paddingTop: "30px" }}>
      <img  src={Pasos} alt="Pasos" />

   
                      </Row></Container>
    </div>
  );
}

export default RatesAndSafes;
